export default __webpack_public_path__ + "static/media/ord-tp-v.639acd2f.png";